export class YearLevelModel {
    Id: number;
    Idx: number;
    Title: string;

    constructor() {
        this.Title = "";
    }
}